const passkey_sign_in = {
    setup_page: {
        title: 'Đơn giản hóa việc đăng nhập',
        subtitle: 'Tạo passkey',
        description: 'Đăng ký passkey bằng sinh trắc học thiết bị, khóa bảo mật như YubiKey, hoặc các phương thức khả dụng khác.',
    },
    trigger_conditional_ui_failed: 'Không thể kích hoạt tự động điền passkey.',
};
export default Object.freeze(passkey_sign_in);
